/**
 * A porta entre o painel e a rota `/painel`. Cada bloco vem com `permitido` e
 * com `atualizadoEm`, o instante do dado mais recente que o sustenta.
 */
import { pedir } from '@/lib/pedido';

type Fechado = { readonly permitido: false };
type Aberto<T> = { readonly permitido: true; readonly atualizadoEm: string | null } & T;
export type Bloco<T> = Fechado | Aberto<T>;

export interface Painel {
  readonly geradoEm: string;
  readonly frota: Bloco<{
    porStatus: readonly { status: string; maquinas: number }[];
    /** `semOrdemAberta`: "Em manutenção" sem O.S. aberta. Nulo para quem não lê a oficina. */
    indisponiveis: readonly { equipamentoId: string; codigo: string; descricao: string; status: string; motivo: string; desde: string; semOrdemAberta: boolean | null }[];
    /** Máquinas "Em manutenção" sem O.S. aberta, contadas inteiras. Nulo para quem não lê a oficina. */
    emManutencaoSemOrdem: number | null;
  }>;
  readonly preventivas: Bloco<{
    vencidas: number;
    venceLogo: number;
    semPontoDePartida: number;
    semLeitura: number;
    primeiras: readonly { equipamentoId: string; equipamento: string; descricao: string; estado: string; gatilho: string; faltam: number | null }[];
  }>;
  readonly ordens: Bloco<{
    abertas: number;
    maquinasParadas: number;
    aguardandoPeca: number;
    paraEncerrar: number;
    antigas: readonly { id: string; numero: number; equipamento: string; etapa: string; sintoma: string; abertaEm: string; etapaDesde: string | null }[];
  }>;
  readonly estoque: Bloco<{
    abaixoDoMinimo: number;
    criticosAbaixo: number;
    faltaParaPreventivas: number;
    abaixo: readonly { produtoId: string; produto: string; produtoCodigo: string; deposito: string; critico: boolean; disponivel: number; estoqueMinimo: number; unidade: string }[];
  }>;
  readonly combustivel: Bloco<{
    foraDaFaixa7Dias: number;
    cobrancasDivergentes: number;
    cobrancasAbertas: number;
    tanquesAcimaDaCapacidade: number;
    ajustesEsperando: number;
    semOperador30Dias: number;
    foraDaFaixa: readonly { abastecimentoId: string; equipamento: string; produto: string; consumo: number; minimo: number | null; maximo: number | null; tipoMedidor: string; ocorridoEm: string }[];
  }>;
  readonly registros: Bloco<{
    naoConferidos: number;
    naoConferidoMaisAntigo: string | null;
    operandoSemApontamento: readonly { equipamentoId: string; codigo: string; descricao: string; ultimoApontamento: string | null }[];
  }>;
  /** Desde a OPE 03 (0037). Opcional: um servidor de antes dela não o manda. */
  readonly apropriacao?: Bloco<{
    abertas: number;
    horasAExplicar: number;
    semResponsavel: number;
    primeiras: readonly { id: string; equipamento: string; dia: string; tipo: string; diferencaH: number }[];
  }>;
}

export const api = {
  painel: () => pedir<Painel>('/painel'),
};
